module.exports = __webpack_public_path__ + "img/locationFill.74b96a3.png";